import { isEmptyOrSpaces } from "@/Utils/stringHelper";

export const isNumericString = (str: string) => /^\d+$/.test(str);
export const isValidPhone = (str: string) => /^[+]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/.test(str);
export const isValidABN = (abn?: string) => !!abn && abn.length === 11 && isNumericString(abn);
export const isValidAccountNumber = (accountNumber: string) => !!accountNumber && /^\w{1,17}$/.test(accountNumber);
export const isValidNdisNumber = (ndis: string) => !isEmptyOrSpaces(ndis) && ndis.length === 9 && isNumericString(ndis) && ndis.startsWith("43");
export const isValidBsb = (bsb: string) => /^\d{3}-?\d{3}$/.test(bsb);
